// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1rNlU","label":"CategoryService_label__1I4Lw","location":"CategoryService_location__fIlxD"};